export default __webpack_public_path__ + "static/media/setting.b64eb08c.png";